import type { FormSelectOptions } from "@ui/components/FormSelect";

export interface FormLoanSimpleData {
	loanType: string;
	loanTypeName: string;
	debt: number;
}

export const LOAN_TYPES: FormSelectOptions = [
	{ label: "Lakáshitel", value: "MORTGAGE" },
	{ label: "Személyi kölcsön", value: "PERSONAL_LOAN" },
	{ label: "Hitelkártya", value: "CREDIT_LINE" },
	{ label: "Folyószámla hitel", value: "OVERDRAFT" },
	{ label: "Gépjárműhitel", value: "CAR_LOAN" },
	{ label: "Egyéb", value: "OTHER" },
];
